import { render, staticRenderFns } from "./CertificateFormPage.vue?vue&type=template&id=534e38f6&"
import script from "./CertificateFormPage.vue?vue&type=script&lang=js&"
export * from "./CertificateFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports